var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-card",
    { attrs: { "no-body": "", header: _vm.header } },
    [
      _c(
        "b-card-body",
        [
          _c("img", {
            attrs: {
              alt: "OSV logo",
              src: require("@/assets/img/osv-logo.png"),
              width: "65",
            },
          }),
          _c("hr"),
          _c(
            "c-switch",
            _vm._b(
              {
                attrs: {
                  color: "primary",
                  id: "vulnsourceEnabled",
                  label: "",
                  disabled: _vm.enabledEcosystems.length === 0,
                },
                model: {
                  value: _vm.vulnsourceEnabled,
                  callback: function ($$v) {
                    _vm.vulnsourceEnabled = $$v
                  },
                  expression: "vulnsourceEnabled",
                },
              },
              "c-switch",
              _vm.labelIcon,
              false
            )
          ),
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("admin.vulnsource_osv_advisories_enable")) +
              "\n    "
          ),
          _c("br"),
          _c(
            "c-switch",
            _vm._b(
              {
                attrs: {
                  color: "primary",
                  id: "aliasSyncEnabled",
                  label: "",
                  title: _vm.$t("admin.vulnsource_alias_sync_enable_tooltip"),
                  disabled: !_vm.vulnsourceEnabled,
                },
                model: {
                  value: _vm.aliasSyncEnabled,
                  callback: function ($$v) {
                    _vm.aliasSyncEnabled = $$v
                  },
                  expression: "aliasSyncEnabled",
                },
              },
              "c-switch",
              _vm.labelIcon,
              false
            )
          ),
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("admin.vulnsource_alias_sync_enable")) +
              "\n    "
          ),
          _c("p", { staticClass: "font-sm text-muted" }, [
            _c("span", { staticClass: "fa fa-warning" }, [_vm._v(" ")]),
            _c(
              "a",
              { attrs: { href: _vm.aliasGitHubIssueUrl, target: "_blank" } },
              [
                _vm._v(
                  _vm._s(_vm.$t("admin.vulnsource_osv_alias_sync_warning"))
                ),
              ]
            ),
          ]),
          _c("hr"),
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("admin.vulnsource_osv_advisories_desc")) +
              "\n    "
          ),
          _c("hr"),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "nvd-feeds-url",
              label: _vm.$t("admin.vulnsource_osv_base_url"),
              "input-group-size": "mb-3",
              rules: "required",
              type: "text",
              lazy: "true",
            },
            model: {
              value: _vm.osvBaseUrl,
              callback: function ($$v) {
                _vm.osvBaseUrl = $$v
              },
              expression: "osvBaseUrl",
            },
          }),
          _c("hr"),
          _c("b-form-group", { attrs: { label: "Ecosystems" } }, [
            _c(
              "div",
              { staticClass: "list-group", staticStyle: { width: "40%" } },
              [
                _vm._l(_vm.enabledEcosystems, function (ecosystem) {
                  return _c(
                    "span",
                    { key: ecosystem },
                    [
                      _c("actionable-list-group-item", {
                        attrs: { value: ecosystem, "delete-icon": true },
                        on: {
                          actionClicked: function ($event) {
                            return _vm.removeEcosystem(ecosystem)
                          },
                        },
                      }),
                    ],
                    1
                  )
                }),
                _c("actionable-list-group-item", {
                  attrs: { "add-icon": true },
                  on: {
                    actionClicked: function ($event) {
                      return _vm.$root.$emit(
                        "bv::show::modal",
                        "ecosystemModal"
                      )
                    },
                  },
                }),
              ],
              2
            ),
          ]),
        ],
        1
      ),
      _c(
        "b-card-footer",
        [
          _c(
            "b-button",
            {
              staticClass: "px-4",
              attrs: {
                disabled: this.vulnsourceEnabled && !this.osvBaseUrl,
                variant: "outline-primary",
              },
              on: { click: _vm.saveUrl },
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("message.update")) + "\n    ")]
          ),
        ],
        1
      ),
      _c("ecosystem-modal", { on: { selection: _vm.updateEcosystem } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }